// extracted by mini-css-extract-plugin
export default {"container":"index_container__LCoq8","card":"index_card__wfiqE"};